export default [
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/seleccionar-registro',
    name: 'register-type',
    redirect: to => ({ name: 'auth-register', query: to.query }),
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset_password/:token',
    name: 'auth-reset-password-v1',
    component: () => import('@/views/authentication/ResetPassword-v2.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/confirmar-cambio-correo/:token',
    name: 'auth-confirm-email-change',
    component: () => import('@/views/authentication/ConfirmEmailChange.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/confirmar-correo/:token',
    name: 'confirm-email',
    component: () => import('@/views/authentication/ConfirmEmail.vue'),
    meta: {
      layout: 'full',
      fullEvenWhenLoggedIn: true,
    },
  },
  {
    path: '/bienvenida',
    name: 'welcome',
    component: () => import('@/views/authentication/Welcome.vue'),
    meta: {
      layout: 'full',
      fullEvenWhenLoggedIn: true,
      requiresAuth: true,
    },
  },
]
